module.exports = __webpack_public_path__ + "img/sld_scb_13_t1_green.587833ff.svg";